export const MAX_HEIGHT = 280;
export const MAX_HEIGHT_IMAGE = 200;
export const MAX_HEIGHT_VIDEO = 210;
